/* eslint-disable react/no-danger */

import React, { createRef } from 'react';
import PropTypes from 'prop-types';
import { Manager, Reference, Popper } from 'react-popper';

import AnalyticsService from '../../services/AnalyticsService';

import GlossaryPopover from './GlossaryPopover';

class GlossaryWord extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            popoverIsOpen: false,
        };

        this.termRef = createRef();
    }

    componentDidMount() {
        window.addEventListener('keydown', this.closeOnEscape);

        const { parentNode } = this.buttonRef.parentNode;

        if (parentNode.nodeName.toLowerCase() === 'a') {
            parentNode.classList.add('glossary-word__link');
        }
    }

    togglePopover = (event) => {
        const {
            popoverIsOpen,
        } = this.state;

        event.preventDefault();

        (popoverIsOpen ? this.closePopover : this.openPopover)();
    }

    openPopover = () => {
        clearTimeout(this.timeout);

        this.setState({
            popoverIsOpen: true,
        });

        AnalyticsService.track('Glossary', 'Open glossary popup', this.props.title);
    }

    closePopover = (event) => {
        if (event) {
            event.preventDefault();
        }

        this.timeout = setTimeout(() => {
            this.setState({
                popoverIsOpen: false,
            });
        }, 300);
    }

    closeOnEscape = (event) => {
        if (event.keyCode === 27) {
            this.closePopover();
        }
    }

    render = () => {
        const {
            original,
            title,
            description,
        } = this.props;

        const {
            popoverIsOpen,
        } = this.state;

        return (
            <Manager>
                <button
                    className="glossary-word__btn"
                    type="button"
                    aria-expanded={popoverIsOpen ? 'true' : 'false'}
                    onClick={this.togglePopover}
                    ref={(el) => { this.buttonRef = el; }}
                >
                    <Reference>
                        {({ ref }) => (
                            <React.Fragment>
                                <span
                                    className="glossary-word__term"
                                    dangerouslySetInnerHTML={{ __html: original }}
                                />
                                <span className="glossary-word__info" ref={ref}>
                                    <svg className="icon-tiny" viewBox="0 0 6 10" role="presentation" focusable="false">
                                        <use xlinkHref="#icon-question-mark" />
                                    </svg>
                                </span>
                            </React.Fragment>
                        )}
                    </Reference>
                </button>
                {popoverIsOpen &&
                    <Popper placement="auto" positionFixed>
                        {({
                            ref, placement, popperProps, style, arrowProps,
                        }) => (
                            <div
                                className="glossary-popover-wrapper"
                                ref={ref}
                                style={style}
                                data-placement={placement}
                                {...popperProps}
                                onMouseEnter={this.openPopover}
                                onFocus={this.openPopover}
                                onBlur={this.closePopover}
                                role="dialog"
                                aria-modal="true"
                            >
                                <GlossaryPopover
                                    title={title}
                                    description={description}
                                    onClose={this.closePopover}
                                />
                                <div
                                    className="glossary-popover__arrow"
                                    ref={arrowProps.ref}
                                    style={arrowProps.style}
                                    data-placement={placement}
                                />
                            </div>
                        )}
                    </Popper>
                }
            </Manager>
        );
    };
}

GlossaryWord.propTypes = {
    title: PropTypes.string.isRequired,
    original: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
};

export default GlossaryWord;
